import { useTranslation } from 'react-i18next';

export const useValidateStatusData = () => {
  const { t } = useTranslation();
  const validateStatusData = (name: string, color: string): string => {
    if (!name.trim()) {
      return t('global.selector.nameRequired') || 'Name is required';
    }
    if (name.length > Number(process.env.REACT_APP_MAX_STATUS_NAME_LENGTH)) {
      return (
        t('exams.totalLeaderBoard.filteredTable.nameTooLong') ||
        `Name must be less than ${process.env.REACT_APP_MAX_STATUS_NAME_LENGTH} characters.`
      );
    }
    if (!color.trim()) {
      return t('global.selector.colorRequired') || 'Color code is required.';
    }
    const hexColorRegex = /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/;
    if (!hexColorRegex.test(color)) {
      return t('exams.totalLeaderBoard.filteredTable.invalidColor') || 'Invalid color';
    }
    return '';
  };

  return { validateStatusData };
};
